import styled from 'styled-components'
import Button from '../../controls/Button'
import { colors, device, media } from '../../theme'
import { NavLink } from 'react-router-dom'
export const Section = styled.section`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background: var(--body-background);
`
export const DocumentList = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  padding: 8px 20px 62px 16px;
  width: auto;
  // height: 88vh;
`
export const Sidebar = styled.aside`
  align-items: stretch;
  box-sizing: border-box;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  height: 100%;
  padding: 20px 20px 0 20px;
  transition: width 0.5s ease-in-out, padding 0.5s ease-in-out;
  .content {
    opacity: 1;
    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;
  }
  ${media.down(device.tablet)`
    width:67px;
    padding: 20px 8px 0 8px;
    .content{
    
    display: none;}
    `}
`
export const DocumentListHeader = styled.div`
  align-items: center;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  height: 48px;
  justify-content: space-between;
`
export const Breadcrumb = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  overflow: hidden;
  cursor: pointer;
`
export const BreadCrumbNav = styled.nav`
  aria-label: breadcrumb;
`
export const BreadcrumbList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: transparent;
  border-radius: 0.25rem;
`
export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text);

  & + &::before {
    font-size: var(--fontSizeBase500);
    font-weight: var(--fontWeight);
    line-height: var(--lineHeightBase500);
    display: inline-block;
    padding-right: 0.5rem;
    color: #6c757d;
    content: '\\00a0\\002F';
  }
`

export const DocumentList_list = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow-y: scroll;
  position: relative;
  border-radius: 5px;
  background: var(--body-background);
  /* WebKit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.bgLighter};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.secondary};
    border-radius: 4px;
    border: 3px solid ${colors.bgLighter};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.primaryDark};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${colors.secondary} ${colors.bgLighter};
`

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  max-width: 190px;
  min-width: 190px;
  color: var(--color-gray-light);
  & > .is-selected {
    color: var(--text);
    background-color: var(--color-gray-lightest);
  }
  ${media.down(device.tablet)`
      display: flex;
    flex-direction: column;
    `}
`


export const Item = styled(NavLink).attrs((props) => ({
  className: (props.$isActive ? props.$activeClass : '') + (props.className || ''),
}))`
  list-style-type: none;
  margin: 4px 0;
  position: relative;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: left;
  justify-content: left;
  box-sizing: border-box;
  width: 100%;
  min-height: 32px;
  padding: 5px 12px;
  border-radius: 4px;
  font-size: var(--fontSizeBase200);
  line-height: var(--lineHeightBase200);
  font-weight: var(--fontWeightRegular);
  font-style: normal;
  text-decoration: none;
  word-break: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  cursor: pointer;
  transition: background-color 130ms ease-out, color 130ms ease-out;
  column-gap: 10px;
  color: inherit;

  & > .icon_document {
    height: 17px;
    width: 17px;
  }
  ${media.down(device.tablet)`
     width: 50px;
      justify-content: center;
    `}
`
export const UploadButton = styled(Button)``
